import { useLocale } from "../contexts/LocaleContext";
import type { AppCurrency, AppLanguage } from "../lib/localePrefs";
import "./LocaleSwitcher.css";

interface Props {
  className?: string;
  showLanguage?: boolean;
  showCurrency?: boolean;
}

export function LocaleSwitcher({
  className = "",
  showLanguage = true,
  showCurrency = true,
}: Props) {
  const { language, currency, setLanguage, setCurrency, t } = useLocale();

  return (
    <div className={`locale-switcher ${className}`.trim()}>
      {showLanguage ? (
        <div
          className="locale-switcher-lang"
          role="group"
          aria-label={t("locale.language")}
        >
          {(["de", "en"] as AppLanguage[]).map((lang) => (
            <button
              key={lang}
              type="button"
              className={`locale-switcher-btn locale-flag-btn${
                language === lang ? " is-active" : ""
              }`}
              aria-pressed={language === lang}
              aria-label={lang === "de" ? "Deutsch" : "English"}
              title={lang === "de" ? "Deutsch" : "English"}
              onClick={() => setLanguage(lang)}
            >
              <img
                src={`/static/img/lang/${lang}.png`}
                alt=""
                aria-hidden="true"
                className="locale-flag-image"
              />
            </button>
          ))}
        </div>
      ) : null}
      {showCurrency ? (
        <select
          className="locale-switcher-currency"
          value={currency}
          aria-label={t("locale.currency")}
          onChange={(e) => setCurrency(e.target.value as AppCurrency)}
        >
          <option value="EUR">{t("locale.eur")}</option>
          <option value="USD">{t("locale.usd")}</option>
          <option value="CHF">{t("locale.chf")}</option>
        </select>
      ) : null}
    </div>
  );
}
